export default "__VITE_ASSET__DhQxvMd7__"